import { Phone, Mail, MapPin, Clock, ShieldCheck, Sparkles } from "lucide-react";
import QuoteForm from "@/components/QuoteForm";
import { CONTACT } from "@/lib/brand";

export default function Contact() {
  return (
    <div data-testid="page-contact" className="bg-slate-50">
      <section className="bg-white border-b border-slate-200">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-20">
          <div className="max-w-3xl">
            <p className="text-sm font-semibold tracking-widest uppercase text-[#388E3C]">
              Contact
            </p>
            <h1 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
              Get your free Cork{" "}
              <span className="text-[#4CAF50]">cleaning quote.</span>
            </h1>
            <p className="mt-5 text-slate-600 text-base sm:text-lg leading-relaxed">
              No obligation. We'll respond quickly — usually within one working
              day. Need it sooner? Give us a call and we'll do our best to
              help.
            </p>
            <div
              data-testid="contact-trust-strip"
              className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-slate-700"
            >
              <span className="inline-flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-[#4CAF50]" />
                Fully insured
              </span>
              <span className="inline-flex items-center gap-2">
                <MapPin className="h-4 w-4 text-[#4CAF50]" />
                Local Cork business
              </span>
              <span className="inline-flex items-center gap-2">
                <Sparkles className="h-4 w-4 text-[#4CAF50]" />
                Reliable & consistent service
              </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20 grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4 min-w-0 space-y-5">
            <a
              href={`tel:${CONTACT.phoneTel}`}
              data-testid="contact-card-phone"
              className="block rounded-3xl bg-white border border-slate-200 p-6 shadow-soft hover:shadow-soft-lg transition-all"
            >
              <div className="h-12 w-12 rounded-2xl bg-[#4CAF50]/12 inline-flex items-center justify-center text-[#388E3C]">
                <Phone className="h-5 w-5" />
              </div>
              <p className="mt-4 text-xs uppercase tracking-widest text-slate-500 font-semibold">
                Call us
              </p>
              <p className="mt-1 font-display text-xl font-bold text-slate-900">
                {CONTACT.phone}
              </p>
              <p className="text-slate-600 text-sm mt-1">
                Mon–Fri 8:00–18:00
              </p>
            </a>

            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="contact-card-email"
              className="block rounded-3xl bg-white border border-slate-200 p-6 shadow-soft hover:shadow-soft-lg transition-all"
            >
              <div className="h-12 w-12 rounded-2xl bg-[#4CAF50]/12 inline-flex items-center justify-center text-[#388E3C]">
                <Mail className="h-5 w-5" />
              </div>
              <p className="mt-4 text-xs uppercase tracking-widest text-slate-500 font-semibold">
                Email
              </p>
              <p className="mt-1 font-display text-base sm:text-lg font-bold text-slate-900 break-all">
                {CONTACT.email}
              </p>
            </a>

            <div
              data-testid="contact-card-location"
              className="rounded-3xl bg-white border border-slate-200 p-6 shadow-soft"
            >
              <div className="h-12 w-12 rounded-2xl bg-[#4CAF50]/12 inline-flex items-center justify-center text-[#388E3C]">
                <MapPin className="h-5 w-5" />
              </div>
              <p className="mt-4 text-xs uppercase tracking-widest text-slate-500 font-semibold">
                Service area
              </p>
              <p className="mt-1 font-display text-xl font-bold text-slate-900">
                {CONTACT.location}
              </p>
              <p className="text-slate-600 text-sm mt-1">
                Cork City & County — wherever your business is.
              </p>
            </div>

            <div className="rounded-3xl bg-slate-900 text-white p-6 shadow-soft-lg">
              <p className="text-xs uppercase tracking-widest text-[#A5D6A7] font-semibold">
                Why book with us
              </p>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-start gap-2.5">
                  <ShieldCheck className="h-4 w-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                  Fully insured & vetted Cork team
                </li>
                <li className="flex items-start gap-2.5">
                  <Clock className="h-4 w-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                  Reply within one working day
                </li>
                <li className="flex items-start gap-2.5">
                  <MapPin className="h-4 w-4 text-[#4CAF50] mt-0.5 flex-shrink-0" />
                  Local — we understand Cork businesses
                </li>
              </ul>
            </div>
          </aside>

          <div className="lg:col-span-8 min-w-0">
            <QuoteForm />
          </div>
        </div>
      </section>
    </div>
  );
}
